import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    if (!email.trim()) {
      setErrorMsg('请输入您的邮箱地址');
      setStatus('error');
      return;
    }
    setLoading(true);
    setErrorMsg('');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9u09m78l97n3eas3evg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
        const msg = (parsed?.meta as Record<string, string>)?.message || (parsed?.message as string) || responseText || '订阅失败，请稍后重试';
        setErrorMsg(msg);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络异常，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-white/20 text-white mb-6">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          订阅我们的邮件通讯
        </h2>
        <p className="text-white/80 max-w-md mx-auto text-sm md:text-base mb-8">
          每周精选一篇深度好文，直接发送到你的邮箱。不打扰，不刷屏，只在有优质内容时出现。
        </p>

        {status === 'success' ? (
          <div className="inline-flex items-center gap-2 px-5 py-3 bg-white/20 text-white rounded-full text-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </div>
            订阅成功！感谢你的关注
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <div className="spam-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="w-full sm:flex-1 px-4 py-3 rounded-full bg-white/15 text-white placeholder-white/50 border border-white/20 focus:outline-none focus:border-white/40 text-sm transition-colors"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-white text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
            >
              {loading ? '提交中...' : '立即订阅'}
            </button>
            {status === 'error' && errorMsg && (
              <p className="text-white/80 text-xs w-full">{errorMsg}</p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}